// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumbsWrapper":"hfcqN3"};